import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_arrow_left.svg'


const _hoisted_1 = {
  "data-testid": "booking-adjust-v4-header",
  class: "flex items-center justify-between gap-4 px-3 py-1.5 border-b border-gray-lp-1400 w-full"
}
const _hoisted_2 = { class: "bg-white flex items-center gap-x-3 border-b border-gray-lp-400 px-6 py-3 flex-shrink-0" }
const _hoisted_3 = { class: "flex flex-row items-center gap-1.5" }
const _hoisted_4 = {
  class: "font-semibold text-2xl text-black-lp-200",
  "data-testid": "booking-adjust-v4-header-title"
}
const _hoisted_5 = { class: "flex items-center gap-3" }
const _hoisted_6 = { class: "relative inline-block" }
const _hoisted_7 = {
  key: 0,
  class: "absolute mt-2 right-0 z-40 py-2 bg-white rounded-xl shadow-md border border-gray-lp-1600",
  style: {"width":"180px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        src: _imports_0,
        class: "w-8 mr-1 cursor-pointer",
        alt: "back",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
      }),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("bookingV4.pageTitleEdit")), 1)
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _withDirectives(_createVNode("div", _hoisted_6, [
        _createVNode("button", {
          "data-testid": "booking-v4-header-receipt-format-selector",
          class: "flex items-center gap-2 rounded-full h-8 px-3 text-xs font-semibold text-black-lp-100 border border-gray-lp-1600",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleReceiptFormatMenu && _ctx.toggleReceiptFormatMenu(...args)))
        }, [
          _createTextVNode(_toDisplayString(_ctx.activeReceiptFormatLabel) + " ", 1),
          _createVNode(_component_Icons, {
            name: "chevron-down",
            class: "w-3"
          })
        ]),
        (_ctx.showReceiptFormatMenu)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.receiptFormatOptions, (option, index) => {
                return (_openBlock(), _createBlock("button", {
                  key: option.value,
                  "data-testid": 
              `booking-v4-header-receipt-format-option-${option.value}`
            ,
                  class: ["flex items-center w-full px-4 py-2 text-xs text-left gap-2.5", 
              [option.value === _ctx.receiptFormat
                ? 'font-semibold text-red-lp-2400'
                : 'text-black-lp-100',
                { 'border-b border-gray-lp-1600': index !== (_ctx.receiptFormatOptions.length-1)}
              ]
            ],
                  onClick: ($event: any) => (_ctx.onReceiptFormatClick(option.value))
                }, [
                  _createVNode(_component_Icons, {
                    name: "printer",
                    class: ["w-6", [
                {'text-gray-lp-3005': option.value !== _ctx.receiptFormat }
              ]]
                  }, null, 8, ["class"]),
                  _createTextVNode(" " + _toDisplayString(option.label), 1)
                ], 10, ["data-testid", "onClick"]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ], 512), [
        [_directive_click_outside, _ctx.closeReceiptFormatMenu]
      ])
    ])
  ]))
}